import { BaseFormatEvent } from 'common/event-handling/base-format-event.model';
import { Constructor } from 'common/event-handling/contructor.type';
import eventBus from 'common/event-handling/event-bus.model';
import {
  PreloadedEvent,
  PreloadErrorEvent
} from 'common/event-handling/events';
import { makeObservable, observable, runInAction } from 'mobx';

export enum FormatState {
  Loading,
  Loaded,
  AssetLoadingError
}

export class FormatStateStore {
  private busSubscriptionIdPreload: string | null = null;
  private busSubscriptionIdPreloadError: string | null = null;

  protected _state: FormatState = FormatState.Loading;

  constructor(preloadClasses?: {
    preload: Constructor<BaseFormatEvent>;
    preloadError: Constructor<BaseFormatEvent>;
  }) {
    this.subscribeToBus(preloadClasses);

    makeObservable<FormatStateStore, '_state'>(this, {
      _state: observable
    });
  }

  get state(): FormatState {
    return this._state;
  }

  // If no events are provided, unsubscribe from both preload and preloadError events
  // else, unsubscribe only from the events that are provided
  protected unsubscribeFromBus(
    events?: Array<'preload' | 'preloadError'>
  ): void {
    const shouldUnsubPreloadError = events
      ? events.indexOf('preloadError') > -1
      : true;

    const shouldUnsubPreload = events ? events.indexOf('preload') > -1 : true;

    if (shouldUnsubPreloadError && this.busSubscriptionIdPreloadError) {
      eventBus.unsubscribe(this.busSubscriptionIdPreloadError);
      this.busSubscriptionIdPreloadError = null;
    }
    if (shouldUnsubPreload && this.busSubscriptionIdPreload) {
      eventBus.unsubscribe(this.busSubscriptionIdPreload);
      this.busSubscriptionIdPreload = null;
    }
  }

  protected subscribeToBus(
    preloadClasses: {
      preload: Constructor<BaseFormatEvent>;
      preloadError: Constructor<BaseFormatEvent>;
    } = {
      preload: PreloadedEvent,
      preloadError: PreloadErrorEvent
    }
  ) {
    this.busSubscriptionIdPreload = eventBus.subscribe(
      preloadClasses.preload,
      _ => {
        runInAction(() => {
          this._state = FormatState.Loaded;
        });
        this.unsubscribeFromBus();
      }
    );

    this.busSubscriptionIdPreloadError = eventBus.subscribe(
      preloadClasses.preloadError,
      _ => {
        runInAction(() => {
          this._state = FormatState.AssetLoadingError;
        });
        this.unsubscribeFromBus();
      }
    );
  }
}
